export function mail() {
  document.addEventListener('DOMContentLoaded', function () {
    var ma1 = "yakuryo" + "@" + "aichi-cc.jp";
    var mt1 = "yakuryo" + String.fromCharCode(64) + "aichi-cc.jp";

    var mailLink = document.getElementById('mailLink');
    if (mailLink) {
        mailLink.innerHTML = '<a href="mailto:' + mt1 + '">' + mt1 + '</a>';
    }
  }); 
}
